import { font, colors, spacing } from '@chegg-ui/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'
import styled from 'styled-components'

export const Header = styled.h1.attrs({
  role: 'heading',
  'aria-level': 1,
})`
  ${AspiraStack};
  font-weight: ${font.weight.bold};
  color: ${colors.dark};
  display: inline;
  margin: ${spacing.px24} 0 0 0;

  font-size: ${font.size.px42};
  line-height: 44px;

  // 'font.size.xxxl' for smaller breakpoints
  @media (max-width: 899px) {
    font-size: 2.25rem;
    line-height: 40px;
  }

  @media (max-width: 599px) {
    font-size: 1.875rem;
    line-height: 34px;
  }
`

export const HeaderText = styled.span<{ headerWeight: string }>`
  font-weight: ${(props) => props.headerWeight};
`

export const SubHeaderText = styled.span`
  font-size: 16px;
  line-height: 20px;
`
